// Quantity steppers (drawer, cart page, PDP cart sync) and the cart note wait this long after the
// last input before sending one request; every cart request counts against Shopify's rate limit
const ON_CHANGE_DEBOUNCE_TIMER = 800;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
